<template>
    <div>
        <p>You have been successfully logged out.</p>
    </div>
</template>

<script>
import quebecUserModal from '../mixins/QuebecUserModal'

export default {
    watch: {
        $route: {
            immediate: true,
            handler () {
                if (this.$store.state.userProfile) {
                    this.$router.replace({ name: 'home' })
                }
            }
        }
    },
    mixins: [
        quebecUserModal
    ]
}
</script>

<style lang="postcss" scoped>
@import "theme";

p {
    font-size: var(--fs-large);
    padding: 80px 0;
    margin-bottom: -200px;
    text-align: center;
}
</style>
